import React, { Suspense, lazy } from "react";
import { Loading } from "@Core/Components/Loader";

const GuestRequestServiceView = lazy(() =>
  import(/* webpackChunkName: "login" */ "./view")
);

const GuestRequestServiceWrapper = (props) => {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <GuestRequestServiceView {...props} />
      </Suspense>
    </>
  );
};

export default GuestRequestServiceWrapper;
